export default "__VITE_ASSET__53c06d62__"